<template>  
  <ListGroupItem style="padding: 0px;">
    <!-- <div class="mx-0 h-100" @click.stop="onExpandClicked">
      <i :class="`fa ${isExpand ? 'fa-chevron-up' : 'fa-chevron-down'}`" style="font-size: 0.8rem; padding-top: 15px; width:40px; height: 40px; text-align: center" />
    </div> -->
    <div class="flex-1 text-break ms-3" v-touch:hold="onTouchHold">
      <div style="font-size: 0.9rem">{{ props.device.group.name }}: {{ props.device.name }}</div>
    </div>
    <div @click.stop="() => props.handleDeleteClick(props.device)" style="text-align: center; padding-top: 10px; width: 40px; height: 40px;">
      <i class="fa-regular fa-trash-can"></i>
    </div>
  </ListGroupItem>
  <!-- <ListGroupItem style="padding: 0px;" v-if="isExpand">
    <div class="text-break me-3" style="padding-left: 40px;">
      <div style="font-size: 0.85rem;">보정 온도값 </div>
    </div>
    <div>
      <div class="btn-group btn-group-sm" style="margin-top: 2px; margin-bottom: 2px; margin-right: 5px;">
        <button type="button" class="btn btn-outline-primary" style="width: 40px; border-radius: 7px 0px 0px 7px;" @click="onMinusClick">-</button>
        <button type="button" class="btn btn-outline-primary" style="width: 60px;">{{ calibration.toFixed(1) }}</button>
        <button type="button" class="btn btn-outline-primary" style="width: 40px; border-radius: 0px 7px 7px 0px;" @click="onPlusClick">+</button>
      </div>
    </div>
    <div class="btn-group btn-group-sm" style="margin-top: 2px; margin-bottom: 2px; padding-right: 15px;">
      <button type="button" class="btn btn-primary" style="margin-top: 2px; margin-bottom: 2px; width: 60px; border-radius: 7px 7px 7px 7px;" @click="handleApplyClick(props.device, calibration)">적용</button>
    </div>
  </ListGroupItem> -->
</template>

<script setup>
import { ref } from 'vue';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';

const props = defineProps(['device', 'handleDeleteClick', 'handleApplyClick']);
const isExpand = ref(false);
const calibration = ref(props.device.item.calibration || 0.0);

const onExpandClicked = (e) => {
  isExpand.value = !isExpand.value;
};

const onMinusClick = () => {
  calibration.value = calibration.value <= -8.0 ? -8.0 : calibration.value - 0.5;
};

const onPlusClick = () => {
  calibration.value = calibration.value >= 8.0 ? 8.0 : calibration.value + 0.5;
};
</script>
